import { useMemo } from 'react'

import { Typography } from '@mui/material'
import { MediaChannelScheduleEntry } from '@nativewaves/nw-cloud-sdk/media'
import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'domain'])

  return useMemo<ColumnDef<MediaChannelScheduleEntry>[]>(
    () => [
      {
        accessorKey: 'name',
        header: t('name'),
        meta: {
          sizing: {
            minWidth: 300,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            minWidth: 100,
            maxWidth: 250,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
    ],
    [t],
  )
}
